// extracted by mini-css-extract-plugin
export default {"removeScheduleModal":"vUFiL_aXmpI3CqSFZfJB"};